import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RegistrarRelacionMontosSalvados } from '../../../interfaces/registrar-relacion-montos-salvados';
import { Regexs } from '@utils/regex';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';
@Component({
  selector: 'app-registrar-relacion-montos-salvados',
  templateUrl: './registrar-relacion-montos-salvados.component.html',
  styleUrls: ['./registrar-relacion-montos-salvados.component.scss'],
})
export class RegistrarRelacionMontosSalvadosComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = [
    'montos_salvados',
    'datos_cliente',
    'cuenta_bancaria',
    'producto_afectado',
    'monto_reclamado',
    'monto_retenido',
    'monto_recuperado',
    'opciones',
  ];
  dataSource = new MatTableDataSource<any>();
  tableValues: RegistrarRelacionMontosSalvados[] = [];

  formTable: FormGroup;
  submit = false;

  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public taskCaseService: TaskCaseService,
    private readonly caseRecordService: CaseRecordService,
    private caseService: CasesService
  ) {}
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  ngOnInit(): void {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }
    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    const values = task.data ? task.data : [];
    this.tableValues = values;
    this.formTable = this.fb.group({
      montos_salvados: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAmount)],
      ],
      datos_cliente: ['', [Validators.required]],
      cuenta_bancaria: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAccountNumber)],
      ],
      producto_afectado: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAccountNumber)],
      ],
      monto_reclamado: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAmount)],
      ],
      monto_retenido: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAmount)],
      ],
      monto_recuperado: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAmount)],
      ],
    });

    this.initializeTable();
  }

  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, {
        data: this.tableValues,
        // ignore: true,
      }) //TODO colocar el last user
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }

  removeData(index: number) {
    this.tableValues.splice(index, 1);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.tableValues })
      .subscribe((caseUpdated) => {
        this.initializeTable();
        this.taskCaseService.taskUpdated.next({ task: caseUpdated });
        this.caseRecordService.updatedRecord.next(true);
      });
  }

  initializeTable() {
    this.dataSource = new MatTableDataSource<RegistrarRelacionMontosSalvados>(
      this.tableValues
    );
    this.dataSource.paginator = this.paginator;
    this.submit = false;
  }
}
